import React, { useState } from 'react'
import { Button, CopyIcon, LinkIcon, SectionTitle, Tooltip } from '@diversioteam/diversio-ds'

import { PulseSurveyLinkProps } from './pulseSurveyLink.types'
import * as S from './pulseSurveyLink.styles'

export const PulseSurveyLink = ({ surveyUrl, size = 'medium' }: PulseSurveyLinkProps) => {
    const [isCopied, setIsCopied] = useState(false)

    const handleCopy = () => {
        navigator.clipboard
            .writeText(surveyUrl)
            .then(() => {
                setIsCopied(true)

                setTimeout(() => {
                    setIsCopied(false)
                }, 3000)
            })
            .catch((error) => {
                console.error('Failed to copy the survey URL:', error)
            })
    }

    return (
        <S.PulseSurveyLinkWrapper size={size}>
            <S.Header>
                <SectionTitle icon={<LinkIcon type="line" />} text="Survey link" />

                <S.Description>Send this link to survey respondents</S.Description>
            </S.Header>

            <S.LinkContainer size={size}>
                <S.LinkInput type="text" value={surveyUrl} readOnly />

                <Tooltip
                    title="Link copied!"
                    variant="light"
                    size="medium"
                    open={isCopied}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                >
                    <Button onClick={handleCopy} color="primary" size={size} leftIcon={<CopyIcon type="line" />}>
                        Copy Link
                    </Button>
                </Tooltip>
            </S.LinkContainer>
        </S.PulseSurveyLinkWrapper>
    )
}
